export const ModalEnum = {
    Confirmation: 'Confirmation',
    Information: 'Information',
}

export default ModalEnum;